var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgK7A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.44 33.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-K7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1297495198144",
    "data-name": 1297495198144
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.26,14.53c-3.54.58-5,3.73-5.73,7.28A27.79,27.79,0,0,0,0,28.05a5.59,5.59,0,0,0,2.15,4.51c1.69,1.24,3.35,1,5.28,1H19.88c1.62,0,4.54.2,6-.28,3.92-1.29,3.82-5.82,3.34-9.5-.43-3.26-1.45-7.33-4.46-8.78-4.15-2-3.57,1.84-9.14,2.54-2.87.36-4.85-.78-7-2.31-1.06-.76-1-.91-2.35-.69Z",
    transform: "translate(-0.01 0)",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1.07A6.53,6.53,0,0,0,9.45,2.79a8.43,8.43,0,0,0,.93,11.06,6.4,6.4,0,0,0,5.37,1.75c3.9-.3,6.7-4.48,6.26-8.69S18-.51,14.1.07Z",
    transform: "translate(-0.01 0)",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgK7A);
export default __webpack_public_path__ + "static/media/K7A.b93b6a5acf25ddd152f49be92dbaa02f.svg";
export { ForwardRef as ReactComponent };